import { useEffect, useState } from "react";
import { addIncentive, GetUserWithRole } from "../../services/incentive";
import CDropdown from "../../common/CDropdown";
import CommonMessage from "../../common/CommonMessage";
import ViewUserIncentive from "./ViewUserIncentive";

const AddIncentive = () => {
    const INITIAL_VALUES={    userId: "",
        orderStatusId: "",
        amount: "",
        percentage: "",
        isActive: true,
    };
    const [users, setUsers] = useState([]);
    const [errors, setErrors] = useState("");
    const [loading, setLoading] = useState(false);
    const[message,setMessage]=useState("");
    const [formData, setFormData] = useState(INITIAL_VALUES);
    const oderStatus = [
        { id: 1, name: "Ready To Ship" },
        { id: 2, name: "Inprogress" },
        { id: 3, name: "OFD" },
        { id: 4, name: "Delivered" }
    ]
    useEffect(() => {
        const userData = async () => {
            try {
                const response = await GetUserWithRole();
                if (
                    response?.statusCode === 200 &&
                    response?.success
                ) {
                    setUsers(response.data || []);
                } else {
                    setUsers([]);
                    setErrors((prev) => ({
                        ...prev,
                        form:
                            response?.message ||
                            "Failed to fetch users",
                    }));
                }
            } catch (err) {
                console.error(err);

                setUsers([]);

                setErrors((prev) => ({
                    ...prev,
                    form:
                        err?.message ||
                        "Something went wrong",
                }));
            }
        };

        userData();
    }, []);
    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        setErrors((prev) => ({
            ...prev,
            [name]: "",
        }));

    };

    const validateForm = () => {
        let newErrors = {};

        if (!formData.userId) {
            newErrors.userId = "Please select user";
        }

        if (!formData.orderStatusId) {
            newErrors.orderStatusId =
                "Order Status is required";
        }

        if (
            !formData.amount &&
            !formData.percentage
        ) {
            newErrors.amount =
                "Enter Amount or Percentage";
        }

        if (
            formData.amount &&
            Number(formData.amount) < 0
        ) {
            newErrors.amount =
                "Amount cannot be negative";
        }
        if (
            formData.percentage &&
            (Number(formData.percentage) < 0 ||
                Number(formData.percentage) > 100)
        ) {
            newErrors.percentage =
                "Percentage must be between 0 and 100";
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
setMessage("");
        if (!validateForm()) {
            return;
        }

        try {
            setLoading(true);

            const payload = {
                ...formData,
                userId: Number(formData.userId),
                orderStatusId: Number(
                    formData.orderStatusId
                ),
                amount: Number(formData.amount || 0),
                percentage: Number(
                    formData.percentage || 0
                ),
                isActive:true,
            };

            console.log("Payload:", payload);
const response = await addIncentive(payload);
            if (response?.statusCode === 200) {
                setMessage("Inentive saved successfully");
                setFormData(INITIAL_VALUES);
                setErrors({});
            } else {
                setMessage("Failed to save Incentive");
            }
        } catch (error) {
            setMessage("something went wrong");
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container mt-4">
            <div className="card shadow">
                <div className="card-header bg-primary text-white">
                    <h4 className="mb-0">Add User Incentive</h4>
                </div>

            <div className="row">
                {message && <CommonMessage text={message}/>}
                <div className="col-lg-12">
                    <div className="custom-card p-3">
                        <form onSubmit={handleSubmit}>
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <CDropdown
                                        label="Select User"
                                        name="userId"
                                        value={formData.userId}
                                        options={users}
                                        optionLabel="name"
                                        optionValue="id"
                                        onChange={
                                            handleChange
                                        }
                                        error={
                                            errors.userId
                                        }
                                        firstOption="Select User"
                                        required
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <CDropdown
                                        label="Select Status"
                                        name="orderStatusId"
                                        value={formData.orderStatusId}
                                        options={oderStatus}
                                        optionLabel="name"
                                        optionValue="id"
                                        onChange={
                                            handleChange
                                        }
                                        error={
                                            errors.orderStatusId
                                        }
                                        firstOption="Select Status"
                                        required
                                    />
                                </div>

                                <div className="col-md-6 mb-3">
                                    <label className="form-label">
                                        Amount
                                    </label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        name="amount"
                                        value={
                                            formData.amount
                                        }
                                        onChange={
                                            handleChange
                                        }
                                    />
                                    {errors.amount && (
                                        <small className="text-danger">
                                            {
                                                errors.amount
                                            }
                                        </small>
                                    )}
                                </div>

                                <div className="col-md-6 mb-3">
                                    <label className="form-label">
                                        Percentage
                                    </label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        name="percentage"
                                        value={
                                            formData.percentage
                                        }
                                        onChange={
                                            handleChange
                                        }
                                    />
                                    {errors.percentage && (
                                        <small className="text-danger">
                                            {
                                                errors.percentage
                                            }
                                        </small>
                                    )}
                                </div>

                                <div className="col-md-12">
                                    <button
                                        type="submit"
                                        className="btn btn-success"
                                        disabled={
                                            loading
                                        }
                                    >
                                        {loading
                                            ? "Submitting..."
                                            : "Submit"}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            </div>
            <div className="row">
                <ViewUserIncentive />
            </div>
        </div>
    );
};
export default AddIncentive;